import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALPERMISSION,
  DELETE_LEGALPERMISSION,
  UPDATE_LEGALPERMISSION,
  ADD_NEW_LEGALPERMISSION,
} from "./actionType";

import {
  getLegalPermissionSuccess,
  getLegalPermissionFail,
  deleteLegalPermissionSuccess,
  deleteLegalPermissionFail,
  updateLegalPermissionSuccess,
  updateLegalPermissionFail,
  addLegalPermissionSuccess,
  addLegalPermissionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalPermissionApi,
  updateLegalPermissionApi,
  deleteLegalPermissionApi,
  addNewLegalPermissionApi
} from "../../helpers/backend_helper";

function* getLegalPermission({ payload: legalPermission }) {
  try {
    const response = yield call(getLegalPermissionApi, legalPermission);
    yield put(getLegalPermissionSuccess(GET_LEGALPERMISSION, response.data));
  } catch (error) {
    yield put(getLegalPermissionFail(GET_LEGALPERMISSION, error));
  }
}

function* onUpdateLegalPermission({ payload: legalPermission }) {
  try {
    const response = yield call(updateLegalPermissionApi, legalPermission);
    yield put(updateLegalPermissionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalPermissionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalPermission({ payload: legalPermission }) {
  try {
    const response = yield call(deleteLegalPermissionApi, legalPermission);
    yield put(deleteLegalPermissionSuccess({ legalPermission, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalPermissionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalPermission({ payload: legalPermission }) {
  try {
    const response = yield call(addNewLegalPermissionApi, legalPermission);
    yield put(addLegalPermissionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalPermissionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalPermission() {
  yield takeEvery(GET_LEGALPERMISSION, getLegalPermission);
}

export function* watchUpdateLegalPermission() {
  yield takeEvery(UPDATE_LEGALPERMISSION, onUpdateLegalPermission);
}

export function* watchDeleteLegalPermission() {
  yield takeEvery(DELETE_LEGALPERMISSION, onDeleteLegalPermission);
}

export function* watchAddNewLegalPermission() {
  yield takeEvery(ADD_NEW_LEGALPERMISSION, onAddNewLegalPermission);
}

function* legalPermissionSaga() {
  yield all([
    fork(watchGetLegalPermission),
    fork(watchDeleteLegalPermission),
    fork(watchUpdateLegalPermission),
    fork(watchAddNewLegalPermission)
  ]);
}

export default legalPermissionSaga;
